import { MessageCircle, ArrowRight } from "lucide-react";
import { openWhatsApp } from "../hooks/useAnalytics";
import { SITE_CONFIG } from "../config";

export const WhatsAppCTA = ({
  message,
  source = "inline_cta",
  title = "¿Hablamos de tu proyecto?",
  subtitle = "Respuesta directa por WhatsApp. Sin formularios, sin esperas.",
  buttonText = "Escribir por WhatsApp",
  variant = "dark",
}) => {
  const isDark = variant === "dark";

  return (
    <div className={`p-8 md:p-12 text-center ${
      isDark
        ? "bg-[#1C2E24] text-white"
        : "bg-white border border-[#E6E2D6]"
    }`}>
      <h3 className={`text-2xl md:text-3xl font-serif mb-3 ${isDark ? "text-white" : "text-[#1C2E24]"}`}>
        {title}
      </h3>
      <p className={`text-sm mb-6 max-w-lg mx-auto ${isDark ? "text-white/60" : "text-[#547055]"}`}>
        {subtitle}
      </p>
      <button
        onClick={() => openWhatsApp(message || SITE_CONFIG.whatsapp.appointmentMessage, source)}
        className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 text-sm uppercase tracking-wider hover:bg-[#20bd5a] transition-colors"
      >
        <MessageCircle size={18} />
        {buttonText}
        <ArrowRight size={16} />
      </button>
      <p className={`text-[10px] mt-3 ${isDark ? "text-white/30" : "text-[#849C8A]"}`}>
        Consulta inicial $7,000 MXN — descontable si avanzas a proyecto
      </p>
    </div>
  );
};

export default WhatsAppCTA;
